import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import config from "config/app.config";
import i18n from "i18next";

const appInsights = new ApplicationInsights({
    config: {
        connectionString:
            "InstrumentationKey=895b6a01-b84d-4163-903f-353f55535b91;IngestionEndpoint=https://northeurope-2.in.applicationinsights.azure.com/;LiveEndpoint=https://northeurope.livediagnostics.monitor.azure.com/",
        enableAutoRouteTracking: true,
        samplingPercentage: 100,
    },
});

const { isDev } = config;

// Allow enabling tracking in dev mode via localStorage for testing
const enableDevTracking = localStorage.getItem("ENABLE_DEV_TRACKING") === "true";

if (!isDev || enableDevTracking) {
    appInsights.loadAppInsights();
    if (enableDevTracking) {
        console.debug("📊 Application Insights tracking enabled in dev mode");
    }
}

export type InsightProps = {
    [name: string]: string | number | boolean | unknown[] | Record<string, unknown>;
};

const getGlobalProperties = (): InsightProps => {
    const storedSystemId = localStorage.getItem("lastKnownSystemId");
    const storedUnitId = localStorage.getItem("lastKnownUnitId");
    const props: InsightProps = {
        "device.viewport": `${
            window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        }x${
            window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight
        }`,
        iframe: window.self !== window.top,
        lang: i18n.language,
        environment: config.environment?.toString() || "unknown",
        isDev: isDev || enableDevTracking,
    };

    if (storedSystemId) {
        props["booking.system"] = storedSystemId;
    }
    if (storedUnitId) {
        props["booking.unit"] = storedUnitId;
    }

    return props;
};

export function trackPageView(name: string, pathname: string) {
    if (isDev && !enableDevTracking) return;
    appInsights.trackPageView({ name, uri: pathname, properties: getGlobalProperties() });
}

export function trackEvent(name: string, properties?: InsightProps) {
    if (isDev && !enableDevTracking) return;
    // Merge global properties with the properties passed in
    properties = { ...getGlobalProperties(), ...properties };
    console.debug(`[Tracking Event] ${name}`, properties);
    appInsights.trackEvent({ name, properties });
}
